import i18n from 'i18next';

export const BASE_FIELDS = [
	{
		name: 'promotionId',
		label: i18n.t('subscribers:coupons.form.fields.promotion_id'),
		type: 'select'
	}
];
